import { render, staticRenderFns } from "./Menuitem.vue?vue&type=template&id=e38d7c5a"
import script from "./Menuitem.vue?vue&type=script&lang=js"
export * from "./Menuitem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports